import { createStore } from '@souche-f2e/muji';
import { getSSOUserInfo } from '@/services/sso';
const state = {
  collapsed: false,
  sso: {
    isLogin: 'unknown',
    userInfo: null,
  },
};
export default createStore({
  state,
  reducers: {
    SET_COLLAPSED(state, payload) {
      state.collapsed = payload;
    },
    SET_SSO_USER(state, payload) {
      Object.assign(state.sso, payload);
    },
  },
  effects: {
    async loadSSOUser() {
      try {
        const userInfo = await getSSOUserInfo();
        this.SET_SSO_USER({
          isLogin: true,
          userInfo,
        });
      } catch (error) {
        this.SET_SSO_USER({
          isLogin: false,
          userInfo: null,
        });
      }
    },
  },
});
